export enum ERoleFieldNames {
  "ID" = "id",
  "Title" = "name",
  "Level" = "slug",
}

export type EUserRoleName =
  | "Superadmin"
  | "Administrator"
  | "Sales"
  | "Sales Head"
  | "Sales Order Management"
  | "Production Manager"
  | "Production Executive"
  | "Project Support CRM"
  | "Commercials"
  | "Production Head"
  | "Light Application Manager"
  | "Product Design"
  | "Partner"
  | "Light Application Engineer"
  | "Store"
  | "Quality Executive"
  | "Quality Head"
  | "User";

export interface IRole {
  [ERoleFieldNames.ID]: number | null;
  [ERoleFieldNames.Title]: EUserRoleName;
  [ERoleFieldNames.Level]: string;
}

export enum EUserFieldNames {
  "ID" = "id",
  "FirstName" = "first_name",
  "LastName" = "last_name",
  "Email" = "email",
  "Username" = "name",
  "Password" = "password",
  "Roles" = "roles",
  "Phone" = "phone",
  "EmployeeCode" = "employee_code",
}

export interface IUserRole {
  id: number;
  name: EUserRoleName;

  slug:
    | "superadmin"
    | "administrator"
    | "sales"
    | "sales-head"
    | "sales-order-management"
    | "production-manager"
    | "production-executive"
    | "project-support-crm"
    | "commercials"
    | "production-head"
    | "light-application-manager"
    | "product-design"
    | "partner"
    | "light-application-engineer"
    | "store"
    | "quality-executive"
    | "quality-head"
    | "user";
}

export interface IUser {
  [EUserFieldNames.ID]: number | null;
  [EUserFieldNames.FirstName]: string;
  [EUserFieldNames.LastName]: string;
  [EUserFieldNames.Email]: string;
  [EUserFieldNames.Username]: string;
  [EUserFieldNames.Roles]: IUserRole[];
  [EUserFieldNames.Phone]: number | null;
  [EUserFieldNames.EmployeeCode]: string | null;
}

export const objToQueryString = (obj: Record<string, string | number>) => {
  const values: string[] = [];

  for (const key in obj)
    if (
      obj[key] !== "" &&
      (typeof obj[key] === "string" || typeof obj[key] === "number")
    )
      values.push(`${key}=${obj[key]}`);

  return values.join("&");
};
